export const DISPLAY_SIZE = Object.freeze({
  MAX_TABLET: 1247,
  MIN_TABLET: 768,
  MAX_MOBILE: 767,
  MIN_MOBILE: 360,
});

export const SIZE = Object.freeze({});
